module.exports = __webpack_public_path__ + "static/media/10k.b1b014f7.webp";